/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import {
  HAZARD_DATA_SUCCESS,
  PDF_GEN_SUCCESS,
  RUN_STARTED,
  SPEX_SERVICE_SUCCESS,
} from '@hbrisk/sp3-risk-model-support/models/runStatuses.js';
import { withProgressCardFunctionality } from '#components/pages/Models/Model/support/Router/withSectionFunctionality/withSectionLevelStatusIndication/support/ProgressCard/index.js';
import { makeCalculatePercentComplete } from '#components/pages/Models/Model/support/Router/withSectionFunctionality/withSectionLevelStatusIndication/support/ProgressCard/calculatePercentComplete.js';
import DownloadsProgressCard from './DownloadsProgressCard.jsx';

// Waits for the final PDF, so the bar slices across every milestone up to it.
const rateByStatus = {
  [RUN_STARTED]: 2000,
  [HAZARD_DATA_SUCCESS]: 8000,
  [SPEX_SERVICE_SUCCESS]: 8000,
};

const calculatePercentComplete = makeCalculatePercentComplete(rateByStatus);

const calculateProgressText = (percentComplete, status) => {
  if (percentComplete < 25) {
    return '';
  }
  switch (status) {
    case RUN_STARTED:
      return 'Updating and running model ...';
    case HAZARD_DATA_SUCCESS:
      return 'Creating downloads ...';
    case SPEX_SERVICE_SUCCESS:
      return 'Creating downloads ...';
    case PDF_GEN_SUCCESS:
      return 'Downloads ready ...';
    default:
      return '';
  }
};

export { calculatePercentComplete, calculateProgressText };

export default withProgressCardFunctionality({
  calculatePercentComplete,
  calculateProgressText,
  desiredStatus: PDF_GEN_SUCCESS,
})(DownloadsProgressCard);
